import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MAINTENANCE, NETWORK_ERROR, SERVER_ERROR } from '@constants/api.ts';
import { ROUTES } from '@router/constants.ts';
import { disableGlobalAlerts, enableGlobalAlerts } from '@store/store.ts';
import { addCallbackUrl, redirectToServerErrorWithCallbackUrl } from '@utils/navigation.ts';

import { getHealthStatus } from '../model/health.slice.ts';
import { useAppDispatch } from './reduxHooks.ts';

const SKIP_ROUTES = [
    ROUTES.DEFAULT.MAINTENANCE,
    ROUTES.DEFAULT.NOT_FOUND,
    ROUTES.DEFAULT.SERVER_ERROR,
    ROUTES.DEFAULT.CLIENT_ERROR,
];

export const useHealthCheck = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        disableGlobalAlerts(); // do not show alerts while fetching or error
        dispatch(getHealthStatus())
            .then(() => {
                // TODO: BBL-365
            })
            .catch((error) => {
                // prevent constant reload
                if (SKIP_ROUTES.some((route) => location.pathname.includes(route))) return;

                switch (error.type) {
                    case MAINTENANCE: {
                        const url = addCallbackUrl(`${window.location.origin}/${ROUTES.DEFAULT.MAINTENANCE}`, window);
                        window.location.replace(url);
                        break;
                    }

                    case SERVER_ERROR:
                        redirectToServerErrorWithCallbackUrl();
                        break;

                    case NETWORK_ERROR: {
                        const url = addCallbackUrl(`${window.location.origin}/${ROUTES.DEFAULT.CLIENT_ERROR}`, window);
                        window.location.replace(url);
                        break;
                    }

                    default:
                        break;
                }
            })
            .finally(() => {
                enableGlobalAlerts(); // Enable global alerts after fetching
            });
    }, [dispatch, location.pathname, navigate]);
};
